import {Personel} from "@/entity/PersonelEntity";

export class order {
    order_id!:number;
    dealer_id!:number;
    cargo_price!:number;
    created_at!:string;
    discount_price!:number;
    payment_price!:number;
    discount_text!:string;
    payment_text!:string;
    is_aktarildi!:number | null;
    bayi_id!:number | null;
    kdv!:number;
    not!:string;
    payment_type_id!:number;
    price!:number;
    installment_price!:number;
    session_id!:number;
    status!:number;
    total_price!:number;
    old_total_price!:number;
    cargo_api_id!:number | null;
    parasut_fatura_id!:number | null;
    cargo_id!:number;
    cargo_takip_no!:number;
    updated_at!:string;
    different_date_sale!:string;
    sozlesme_path!:string;
    urun_turu_id!:number;
    personel!:Personel;
    installment!:number;
    installment_count!:number;
    installment_text!:string;
    musteri_no!:number | null;
    lisans_no!:number | null;

    reportLoading?: boolean;
    reportData?: any;

}